/**
 * Breakdown:
 * - ^[A-Za-z]                             - start with a letter
 * - (?:                                   - start group for subsequent allowed chunks
 * -   (?:[ '-])?                        - optional single separator (space, straight apostrophe, or hyphen-minus)
 * -   [A-Za-z]+                         - at least one letter
 * - )*                                  - repeat
 * - $                                   - end
 * This allows names like Anne-Marie O'Brien, D'Angelo, C'David O'Cob-Dam
 */
export const validNamePattern = "^[A-Za-z]+(?:[ '-][A-Za-z]+)*$";

// Email RegEx has been taken from https://emailregex.com/
export const validEmailPattern =
  '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
export const emailMaxLength = 255;

export const promoCodePattern = '^[a-zA-Z0-9]{0,20}$';

export const validLicenceNumberPattern = '^[a-zA-Z]{2}[0-9]{6}$';
export const validResidencyNumberLetterPattern = '^[a-zA-Z0-9_.-]*$';

export const numbersOnlyPattern = '^[0-9]*$';

export const validVerbalPasswordCharsPattern = '^[a-zA-Z0-9]+$';
export const validVerbalPasswordLettersPattern = '^(.*[a-zA-Z]+.*){2,}$'; // 2 or more letters anywhere in string
export const validVerbalPasswordNumbersPattern = '^(.*[0-9]+.*){2,}$'; // 2 or more numbers anywhere in string
export const validVerbalPasswordMinLength = 6;
export const validVerbalPasswordMaxLength = 15;

export const APPLY_BTN_LABEL = 'Start application';
export const RESUME_BTN_LABEL = 'Resume application';
export const APPLE_MERCHANT = 'Apple';
export const AGREE_AND_CONTINUE_BTN_LABEL = 'Agree and continue';
export const APPLICATION_RESUME_PERIOD_DAYS = 60;
export const APPLICATION_START_DATE_PARAMETER = 'applicationStartDate';
export const APPLICATION_START_DATE_PATTERN = '^\\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$'; // ISO 8601 Date

// Modern web browsers aggressively predict credit card forms and provide auto-fill.
// Here we use a mis-labeled attribute to prevent auto-fill.
// https://stackoverflow.com/a/64143471/1401634
export const PREVENT_CREDIT_CARD_AUTOFILL = ['tel', 'cc-csc', 'organization'];

export * from './titleOptions.js';
export { countryOptions } from './countryOptions.js';
export * from './applicationReasonOptions.js';
export { relationshipStatusOptions } from './relationshipStatusOptions.js';
export { yesNoOptions } from './yesNoOptions.js';
export * from './industryOptions.js';
export * from './residentialStatusOptions.js';
export * from './employmentStatusOptions.js';
export { occupationOptions } from './occupationOptions.js';
export { OptionUser, OptionSystem, creditLimitSourceOptions } from './creditLimitSourceOptions.js';
export * from './medicareCardColourOptions.js';
export * from './externalLinks.js';
export * from './products.js';
